import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a small round side table (~0.45 diameter, top at 0.55):
// walnut top on a slim matte-black pedestal and disc base.
const WALNUT = "#7a5a3a";
const BLACK = "#2e2e30";

export const sideTable = defineModel({
  id: "side-table",
  batchId: "modern",
  name: "Side table",
  tags: ["modern", "interior", "furniture", "table", "living-room"],
  summary: "A small round walnut side table on a slim black pedestal.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // walnut top (top surface at 0.55)
      { geometry: new THREE.CylinderGeometry(0.225, 0.225, 0.04, 12), color: WALNUT, position: [0, 0.53, 0] },
      // slim pedestal
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.48, 8), color: BLACK, position: [0, 0.27, 0] },
      // disc base
      { geometry: new THREE.CylinderGeometry(0.15, 0.17, 0.03, 12), color: BLACK, position: [0, 0.015, 0] },
    ];
  },
  animations: [],
});
